"use strict";

function shareTarget(el) {
  const root = el.closest("[data-share-url]");
  return {
    url: (root && root.dataset.shareUrl) || window.location.href,
    title: (root && root.dataset.shareTitle) || document.title,
  };
}

copy_url();
function copy_url() {
  document.querySelectorAll(".js-copy-url").forEach((button) => {
    const idle = button.querySelector(".js-copy-idle");
    const done = button.querySelector(".js-copy-done");

    button.addEventListener("click", (event) => {
      event.preventDefault();
      navigator.clipboard.writeText(shareTarget(button).url);

      if (!idle || !done) return;
      done.classList.remove("hidden");
      idle.classList.add("hidden");
      setTimeout(function () {
        done.classList.add("hidden");
        idle.classList.remove("hidden");
      }, 3000);
    });
  });
}

native_share();
function native_share() {
  document.querySelectorAll(".js-native-share").forEach((button) => {
    // Only surface the button where the browser can actually open a share sheet;
    // copy-link stays as the fallback everywhere else.
    if (!navigator.share) return;

    button.hidden = false;
    button.classList.remove("hidden");
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const { url, title } = shareTarget(button);
      navigator.share({ title, url }).catch(() => {
        /* dismissed by the user */
      });
    });
  });
}

site_nav();
function site_nav() {
  const nav = document.querySelector("[data-nav]");
  if (!nav) return;

  // A group's name and its "+" both disclose the same panel, so state is kept
  // per panel and every toggle pointing at it is updated together.
  const toggles = [...nav.querySelectorAll("[data-nav-toggle]")];
  const groups = new Map();
  toggles.forEach((toggle) => {
    const id = toggle.getAttribute("aria-controls");
    const panel = document.getElementById(id);
    if (!panel) return;
    if (!groups.has(id)) groups.set(id, { panel, toggles: [] });
    groups.get(id).toggles.push(toggle);
  });

  function setOpen(group, open) {
    group.toggles.forEach((t) =>
      t.setAttribute("aria-expanded", String(open))
    );
    // `inert` keeps the closed panel's links out of the tab order while the
    // panel stays in the DOM for the open/close transition.
    if (open) {
      group.panel.setAttribute("data-open", "");
      group.panel.removeAttribute("inert");
    } else {
      group.panel.removeAttribute("data-open");
      group.panel.setAttribute("inert", "");
    }
  }

  function closeAll(except) {
    groups.forEach((group) => {
      if (group !== except) setOpen(group, false);
    });
  }

  const isOpen = (group) => group.panel.hasAttribute("data-open");

  groups.forEach((group) => {
    setOpen(group, false);
    group.toggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const willOpen = !isOpen(group);
        closeAll(group);
        setOpen(group, willOpen);
      });
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const open = [...groups.values()].find(isOpen);
    if (!open) return;
    closeAll();
    open.toggles[0].focus();
  });

  document.addEventListener("click", (event) => {
    if (!nav.contains(event.target)) closeAll();
  });
}

sticky_nav();
function sticky_nav() {
  const nav = document.querySelector("[data-nav]");
  const sentinel = document.querySelector("[data-nav-sentinel]");
  if (!nav || !sentinel || !("IntersectionObserver" in window)) return;

  // The sentinel sits directly above the bar, so it leaving the viewport is
  // exactly the moment the bar pins to the top.
  new IntersectionObserver(
    ([entry]) => nav.classList.toggle("is-stuck", !entry.isIntersecting),
    { threshold: 0 }
  ).observe(sentinel);
}

mobile_header();
function mobile_header() {
  const bar = document.getElementById("headerbar");
  if (!bar) return;

  const mobile = window.matchMedia("(max-width: 767px)");
  // Stay pinned for the first couple of screens; past that, hide on the way
  // down and come back on the way up. Small deltas are ignored so a wobbly
  // thumb doesn't flicker it.
  const HOLD_HEIGHTS = 2;
  const JITTER = 4;
  let lastY = window.scrollY;
  let ticking = false;

  function update() {
    ticking = false;
    const y = window.scrollY;
    const delta = y - lastY;
    lastY = y;

    if (!mobile.matches) {
      bar.classList.remove("is-hidden");
      return;
    }
    if (y <= bar.offsetHeight * HOLD_HEIGHTS || delta < -JITTER) {
      bar.classList.remove("is-hidden");
    } else if (delta > JITTER) {
      bar.classList.add("is-hidden");
    }
  }

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );
  mobile.addEventListener("change", update);
}

nav_sheet();
function nav_sheet() {
  const sheet = document.querySelector("[data-nav-sheet]");
  const openers = [...document.querySelectorAll("[data-nav-sheet-open]")];
  if (!sheet || !openers.length) return;

  const closers = [...sheet.querySelectorAll("[data-nav-sheet-close]")];
  let lastFocused = null;

  function open() {
    lastFocused = document.activeElement;
    sheet.hidden = false;
    // Next frame, so the opacity transition has a starting value to animate from.
    requestAnimationFrame(() => sheet.setAttribute("data-open", ""));
    openers.forEach((b) => b.setAttribute("aria-expanded", "true"));
    document.body.style.overflow = "hidden";
    (closers[0] || sheet).focus({ preventScroll: true });
  }

  function close() {
    sheet.removeAttribute("data-open");
    openers.forEach((b) => b.setAttribute("aria-expanded", "false"));
    document.body.style.overflow = "";
    const done = () => {
      sheet.hidden = true;
      sheet.removeEventListener("transitionend", done);
    };
    sheet.addEventListener("transitionend", done);
    if (lastFocused) lastFocused.focus({ preventScroll: true });
  }

  openers.forEach((button) => {
    button.addEventListener("click", () => {
      if (button.getAttribute("aria-expanded") === "true") close();
      else open();
    });
  });

  closers.forEach((button) => button.addEventListener("click", close));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !sheet.hidden) close();
  });

  // Following a link should not leave the sheet open behind a back-navigation
  sheet.querySelectorAll("a[href]").forEach((link) => {
    link.addEventListener("click", () => {
      document.body.style.overflow = "";
    });
  });
}

section_rails();
function section_rails() {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

  document.querySelectorAll("[data-rail]").forEach((rail) => {
    const track = rail.querySelector("[data-rail-track]");
    const items = [...rail.querySelectorAll("[data-rail-item]")];
    const prev = rail.querySelector("[data-rail-prev]");
    const next = rail.querySelector("[data-rail-next]");
    const thumb = rail.querySelector("[data-rail-thumb]");
    if (!track || !items.length) return;

    // One "page" is whatever is currently visible, so the arrows always move
    // by 4 on desktop, 2 on tablet, 1 on mobile without knowing the breakpoint.
    const page = () => track.clientWidth;
    const maxScroll = () => track.scrollWidth - track.clientWidth;

    function update() {
      const x = track.scrollLeft;
      const max = maxScroll();
      const atStart = x <= 1;
      const atEnd = x >= max - 1;
      prev.setAttribute("aria-disabled", String(atStart));
      next.setAttribute("aria-disabled", String(atEnd));
      prev.tabIndex = atStart ? -1 : 0;
      next.tabIndex = atEnd ? -1 : 0;

      if (thumb) {
        thumb.style.setProperty("--nw-rail-frac", track.clientWidth / track.scrollWidth);
        thumb.style.setProperty("--nw-rail-pos", max > 0 ? (x / max) * (1 - track.clientWidth / track.scrollWidth) : 0);
      }
    }

    function go(dir) {
      track.scrollBy({
        left: dir * page(),
        behavior: reduced.matches ? "auto" : "smooth",
      });
    }

    prev.addEventListener("click", () => go(-1));
    next.addEventListener("click", () => go(1));

    // Arrow keys when the track itself has focus
    track.addEventListener("keydown", (event) => {
      if (event.key === "ArrowRight") { event.preventDefault(); go(1); }
      if (event.key === "ArrowLeft") { event.preventDefault(); go(-1); }
    });

    let ticking = false;
    track.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener("resize", update);

    // Cards come forward as they enter the track's viewport
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((e) => e.target.classList.toggle("is-in-view", e.isIntersecting)),
        { root: track, threshold: 0.6 }
      );
      items.forEach((el) => io.observe(el));
    } else {
      items.forEach((el) => el.classList.add("is-in-view"));
    }

    rail.classList.add("is-ready");
    update();
  });
}

reframe_video();
function reframe_video() {
  reframe("iframe");
}

window.addEventListener(
  "load",
  function () {
    Lightense(".nw-content img");
  },
  false
);

TOC();
function TOC() {
  tocbot.init({
    tocSelector: "#nw-toc",
    contentSelector: ".nw-content",
    headingSelector: "h2",
    hasInnerContainers: true,
  });
}

has_text();
function has_text() {
  let names = document.getElementsByClassName("trex_has_text");
  [].forEach.call(names, function (el) {
    el.innerText = getFirstLetters(el.innerText);
  });
}

function getFirstLetters(str) {
  const firstLetters = str
    .split(" ")
    .map((word) => word[0])
    .join("");

  return firstLetters;
}

topSlide();
function topSlide() {
  document.addEventListener("DOMContentLoaded", function () {
    // if (document.getElementById("nw-headlines")) {
    //   let headlines = new Splide("#nw-headlines", {
    //     fixedWidth: "412px",
    //     gap: "24px",
    //     pagination: false,
    //     autoplay: false,
    //     type: "slide",
    //     resetProgress: false,
    //     lazyLoad: "sequential",
    //     //interval: 20000,
    //     arrows: false,
    //     breakpoints: {
    //       767: {
    //         fixedWidth: "350.5px",
    //       },
    //       500: {
    //         fixedWidth: "100%",
    //       },
    //     },
    //   });
    //   headlines.mount();
    // }
  });
}

// issuePosts();
// function issuePosts() {
//   document.addEventListener("DOMContentLoaded", function () {
//     //   var els = document.getElementsByClassName("issue-slider");
//     //   if (els) {
//     //     Array.from(els).forEach((el) => {
//     //       new Splide(el, {
//     //         type: "loop",
//     //         //drag   : 'free',
//     //         gap: "30px",
//     //         autoWidth: true,
//     //         autoScroll: false,
//     //         arrows: false,
//     //         pagination: false,
//     //       }).mount(window.splide.Extensions);
//     //     });
//     //   }
//   });
// }

// featuredPosts();
// function featuredPosts() {
//   document.addEventListener("DOMContentLoaded", function () {
//     if (document.getElementById("nw-featured-posts")) {
//       // let ft_posts = new Splide("#nw-featured-posts", {
//       //   type: "fade",
//       //   arrows: false,
//       // });
//       // ft_posts.mount();
//       // document.getElementById("fp-next").addEventListener("click", function () {
//       //   ft_posts.go(">");
//       // });
//       // document.getElementById("fp-prev").addEventListener("click", function () {
//       //   ft_posts.go("<");
//       // });
//     }
//   });
// }

subscribe();
function subscribe() {
  document.addEventListener("DOMContentLoaded", function () {
    const subscribeEl = document.getElementById("nw-subscribe");
    if (subscribeEl) {
      // console.log("adding subscribe splide!");
      console.dir(subscribeEl);
      new Splide(subscribeEl, {
        type: "loop",
        //drag   : 'free',
        gap: "30px",
        autoWidth: true,
        autoScroll: {
          speed: 0.7,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
        arrows: false,
        pagination: false,
      }).mount(window.splide.Extensions);
      // console.log("splide added");
    }
  });
}

backToTop();
function backToTop() {
  if (document.getElementById("nw-back-top")) {
    document
      .getElementById("nw-back-top")
      .addEventListener("click", function () {
        window.scroll({ top: 0, behavior: "smooth" });
      });
  }
}

load_more_posts();
function load_more_posts() {
  if (document.getElementById("trex_blog")) {
    let elem = document.getElementById("trex_blog");
    let infScroll = new InfiniteScroll(elem, {
      append: ".trex_post",
      button: ".infinite-scroll-button",
      debug: true,
      hideNav: ".pagination",
      history: false,
      path: ".pagination .older-posts",
      scrollThreshold: false,
      status: ".infinite-scroll-status",
    });
  }
}

switchMode();
function switchMode() {
  if (document.getElementById("trex_switcher") !== null) {
    if (localStorage.newswire === "dark") {
      document.documentElement.classList.add("dark");
      let checkbox = document.getElementById("switch_dark");
      checkbox.click();
    }

    if (document.getElementById("trex_sepia")) {
      document
        .getElementById("trex_sepia")
        .addEventListener("click", function () {
          document.documentElement.classList.remove("dark");
          localStorage.newswire = "sepia";
        });
    }

    if (document.getElementById("trex_light")) {
      document
        .getElementById("trex_light")
        .addEventListener("click", function () {
          document.documentElement.classList.remove("dark");
          localStorage.newswire = "light";
        });
    }

    if (document.getElementById("trex_dark")) {
      document
        .getElementById("trex_dark")
        .addEventListener("click", function () {
          localStorage.newswire = "dark";
          document.documentElement.classList.add("dark");
          document.documentElement.classList.remove("light");
          document.documentElement.classList.remove("sepia");
        });
    }
  }
}
